let ctx;
export const isMuted = () => localStorage.getItem("frogfirst_muted") === "1";
export const setMuted = (m) => localStorage.setItem("frogfirst_muted", m ? "1" : "0");

const ac = () => {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

const croak = (c, t, f1, f2, dur) => {
  const osc = c.createOscillator();
  const gain = c.createGain();
  const filt = c.createBiquadFilter();
  osc.type = "sawtooth";
  osc.frequency.setValueAtTime(f1, t);
  osc.frequency.exponentialRampToValueAtTime(f2, t + dur);
  filt.type = "lowpass";
  filt.frequency.setValueAtTime(450, t);
  gain.gain.setValueAtTime(0.0001, t);
  gain.gain.exponentialRampToValueAtTime(0.35, t + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  osc.connect(filt).connect(gain).connect(c.destination);
  osc.start(t);
  osc.stop(t + dur + 0.05);
};

export const playRibbit = () => {
  if (isMuted()) return;
  try {
    const c = ac();
    const t = c.currentTime;
    croak(c, t, 150, 95, 0.16);
    croak(c, t + 0.2, 170, 105, 0.2);
  } catch {}
};

export const playSplash = () => {
  if (isMuted()) return;
  try {
    const c = ac();
    const t = c.currentTime;
    const dur = 0.6;
    const buf = c.createBuffer(1, c.sampleRate * dur, c.sampleRate);
    const data = buf.getChannelData(0);
    for (let i = 0; i < data.length; i++) data[i] = (Math.random() * 2 - 1) * (1 - i / data.length);
    const src = c.createBufferSource();
    src.buffer = buf;
    const filt = c.createBiquadFilter();
    filt.type = "bandpass";
    filt.Q.value = 0.8;
    filt.frequency.setValueAtTime(1400, t);
    filt.frequency.exponentialRampToValueAtTime(300, t + dur);
    const gain = c.createGain();
    gain.gain.setValueAtTime(0.0001, t);
    gain.gain.exponentialRampToValueAtTime(0.4, t + 0.03);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    src.connect(filt).connect(gain).connect(c.destination);
    src.start(t);
    const plop = c.createOscillator();
    const pg = c.createGain();
    plop.type = "sine";
    plop.frequency.setValueAtTime(500, t);
    plop.frequency.exponentialRampToValueAtTime(150, t + 0.15);
    pg.gain.setValueAtTime(0.0001, t);
    pg.gain.exponentialRampToValueAtTime(0.3, t + 0.02);
    pg.gain.exponentialRampToValueAtTime(0.0001, t + 0.2);
    plop.connect(pg).connect(c.destination);
    plop.start(t);
    plop.stop(t + 0.25);
  } catch {}
};

export const playPop = () => {
  if (isMuted()) return;
  try {
    const c = ac();
    const t = c.currentTime;
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.type = "sine";
    osc.frequency.setValueAtTime(300, t);
    osc.frequency.exponentialRampToValueAtTime(700, t + 0.08);
    gain.gain.setValueAtTime(0.0001, t);
    gain.gain.exponentialRampToValueAtTime(0.25, t + 0.015);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.12);
    osc.connect(gain).connect(c.destination);
    osc.start(t);
    osc.stop(t + 0.15);
  } catch {}
};
